import React, {Component} from "react";
import qs from 'query-string';
import CreditLineApiHandler from "../../creditLines/CreditLineApiHandler";
import {v4 as uuidv4} from 'uuid';
import ClSuccessPage from "./ClSuccessPage";
import Dialog from "@material-ui/core/Dialog";
import whitelistedEmailsList from "../../creditLines/components/whitelistedEmailsForOperations.json";

class CreateCreditLine extends Component {
    constructor(props) {
        super(props);

        //Logic for Today's Date
        var today = new Date();
        var dd = today.getDate();
        var mm = today.getMonth() + 1;
        var yyyy = today.getFullYear();
        if (dd < 10) {
            dd = '0' + dd;
        }
        if (mm < 10) {
            mm = '0' + mm;
        }
        today = yyyy + '-' + mm + '-' + dd;

        this.state = {
            bzid: null,
            businessName: null,
            creditLineStatus: "ACTIVE",
            startDate: today,
            productSelected: "JT-PDC",
            firstName: null,
            lastName: "",
            phone: null,
            overallLimit: null,
            convenienceFeeRate: null,
            newConvenienceFeeRate:null,
            interestRate: null,
            creditLineStatusSet: null,
            creditProductDtoSet: null,
            productChoices: ["JT-PDC", "JT-MULTIMODE"],
            tenureChoices:[14,21],
            showErrorModal: null,
            error: null,
            submissionObject: [],
            hasSubmitted: false,
            isSuccessful: false,
            bzidWarn: null,
            phoneWarn: null,
            creditProductWarn: null,
            businessNameWarn: null,
            overallLimitWarn: null,
            overallLimitHigherWarn:false,
            phoneNumberLengthWarn: null,
            isSubmitted: false,
            clickedSuccessModalOk: false,
            convenienceFeePercent:null,
            tenure:21, //setting 21 as default
            subsidizedDays:7,
            subsidizedDaysChoices:[7,14],
            isJTUser: false,
            defaultReason:"Creating New Credit Line from Activate Credit"
        }
    }

    componentWillMount() {
        this.fetchConfig();
        var businsessId = qs.parse(this.props.location.search).bzid ? qs.parse(this.props.location.search).bzid : JSON.parse(localStorage.getItem("searched_bzid"));
        if (businsessId) {
            this.setState({
                bzid: businsessId
            });
            this.fetchCustomerDetails(businsessId);
        }
    }

    componentDidMount() {
        this.fetchConfig();
        var businsessId = qs.parse(this.props.location.search).bzid ? qs.parse(this.props.location.search).bzid : JSON.parse(localStorage.getItem("searched_bzid"));
        var tenantId = JSON.parse(localStorage.getItem("user")).userProfile.tenantId;
        let loggedInUser = JSON.parse(localStorage.getItem("user"));
        let jumbotailUser = loggedInUser.userProfile.loginId.split('@');
        console.log("tenant is", tenantId);
        if (tenantId === "TENANT-135108" && whitelistedEmailsList["emailIds"].includes(loggedInUser.userProfile.loginId)) {
            this.setState({
                isJTUser: true
            })
        }
        if (businsessId) {
            this.setState({
                bzid: businsessId
            });
            this.fetchCustomerDetails(businsessId);
        }
        let preFillCreditRelatedData = setTimeout(this.prefillCreditData, 1000);
        let preFillBusinessRelatedData = setTimeout(this.prefillBusinessData, 1000);
    }

    prefillCreditData = () => {
        let selectedProduct = this.state.productSelected;
        let productSet = this.state.creditProductDtoSet;
        console.log("Hello product", selectedProduct);
        console.log("productSet", productSet);
        if (selectedProduct && productSet) {
            var productObj = productSet.filter(function (obj) {
                return obj.creditProductName === selectedProduct;
            })[0];
            // console.log("product obj is ",productObj);
            if (productObj != null) {
                let convenienceFeeRate = productObj.convenienceFeeRate;
                let interestRate = productObj.interestRate;
                let convenienceFeePercent = productObj.convenienceFeeTaxPercentage;
                // let tenure = productObj.tenure;
                let subsidizedDays = productObj.subsidizedDays;

                let newConvenienceFeeRate = convenienceFeeRate * (1 + (convenienceFeePercent/100));
                this.setState({
                    convenienceFeeRate: convenienceFeeRate,
                    newConvenienceFeeRate: newConvenienceFeeRate + "%",
                    interestRate: interestRate,
                    convenienceFeePercent: convenienceFeePercent + "%",
                    // tenure: tenure,
                    subsidizedDays : subsidizedDays
                });
            }
        }
        this.updateOverallLimit();
    }

    prefillBusinessData = () => {
        let bzid = this.state.bzid;
        console.log("BZID in prefill Business data is, ", bzid);
    }


    handleFormData = (e) => {
        this.setState({
            [e.target.name]: e.target.value.trim()
        });
    };

    handleSelect = (e) => {
        console.log("Handle select function start")
        this.setState({
            productSelected: e.target.value
        }, this.prefillCreditData)
    };

    handleTenureSelect = (e) => {
        console.log("Handle Tenure Select function start");
        this.setState({
            tenure:e.target.value
        });
    };

    handleSubsidizedDaysSelect = (e) => {
        console.log("Handle SubsidizedDays Select function start");
        this.setState({
            subsidizedDays:e.target.value
        });
    };

    successLogo = () => {
        return (
            <img
                className="showImage"
                src="tick.png"
                alt="Success"
            />
        )
    }

    fetchCustomerDetails(bzid) {
        CreditLineApiHandler.getCustomerDetails(bzid)
            .then(
                function (res) {
                    console.log("Got customer Details ", res)
                    this.setState({
                        phone: res.phoneNumber,
                        businessName: res.businessName
                    })
                }.bind(this)
            )
            .catch((data) => {
                this.setState({
                    error: data.error,
                    showErrorModal: true
                });
            });
        this.updateOverallLimit();
    }

    updateOverallLimit = () => {
        var limit = this.state.productSelected === "JT-PDC" ? 30000 : 15000
        this.setState({
            overallLimit: limit
        });
    }

    fetchConfig() {
        CreditLineApiHandler.getCreditLineConfig()
            .then(
                function (resp) {
                    console.log("Res 1 ", resp)
                    this.setState({
                        creditLineStatusSet: resp.creditLineStatusSet,
                        creditProductDtoSet: resp.creditProductDtoSet
                    });
                }.bind(this)
            )
            .catch((data) => {
                this.setState({
                    error: data.error,
                    showErrorModal: true
                });
            });
    }

    handleSubmit = (e) => {
        e.preventDefault();
        const {bzid, phone, productSelected, businessName, overallLimit} = this.state;
        let limitNotHigh = true;
        if (phone.length > 0 && phone.length !== 10) {
            this.setState({
                phoneNumberLengthWarn: true
            })
        }
        if (!bzid) {
            this.setState({
                bzidWarn: true
            })
        }
        if (!phone) {
            this.setState({
                phoneWarn: true
            })
        }
        if (!productSelected) {
            this.setState({
                creditProductWarn: true
            })
        }
        if (!businessName) {
            this.setState({
                businessNameWarn: true
            })
        }
        if (!overallLimit) {
            this.setState({
                overallLimitWarn: true
            })
        }
        else if(overallLimit > 15000 && productSelected === "JT-MULTIMODE"){
            limitNotHigh = false
            this.setState({
                overallLimitHigherWarn:true
            })
        }
        else if(overallLimit > 30000 && productSelected === "JT-PDC"){
            limitNotHigh = false
            this.setState({
                overallLimitHigherWarn:true
            })
        }

        if (e){
            console.log("event is ",e);
        }
        if (bzid && (phone.length == 10) && productSelected && businessName && overallLimit && limitNotHigh) {
            console.log("Form Submitted");
            var sendStartDateInEpoch = Date.parse(this.state.startDate);
            let obj = {
                creditUserId: this.state.bzid,
                creditProductName: this.state.productSelected,
                interestRate: this.state.interestRate,
                convenienceFeeRate: this.state.convenienceFeeRate,
                startDate: sendStartDateInEpoch,
                phoneNumber: this.state.phone,
                businessName: this.state.businessName,
                status: this.state.creditLineStatus,
                overallLimit: this.state.overallLimit,
                transactionalLimit: this.state.overallLimit,
                reason:this.state.defaultReason,
                tenure:this.state.tenure,
                subsidizedDays:this.state.subsidizedDays
            }
            this.setState({
                submissionObject: [...this.state.submissionObject, obj],
                isReadyForSubmit: true
            });
            console.log("Submission data packet is ", obj);
             
            this.submitForm(obj);
         
        }
    }

    submitForm = (obj) => {

        CreditLineApiHandler.submitCreditLineDetails(obj)
            .then(
                function (resp) {
                    console.log("submitted form");
                    console.log("Res 2 ", resp)
                    this.setState({
                        hasSubmitted: true,
                        isSuccessful: true,
                        bzidWarn: false,
                        phoneWarn: false,
                        creditProductWarn: false,
                        businessNameWarn: false,
                        overallLimitWarn: false,
                        phoneNumberLengthWarn: false,
                        overallLimitHigherWarn: false
                    });
                }.bind(this)
            )
            .catch((data) => {
                this.setState({
                    error: data.error,
                    showErrorModal: true
                });
            });
    }

    handleSuccessModalOk = (e) => {
        console.log("Inside Modal ok Click");
        this.setState({
            hasSubmitted: false,
            bzid: "",
            phone: "",
            clickedSuccessModalOk: true,
            businessName: "",
            isSuccessful: false
        });
    }

    searchBzid = (e) => {
        let businsessId = e.target.previousSibling.value.trim();

        this.setState({
            bzid: businsessId
        });
        this.fetchCustomerDetails(businsessId);
    }


    render() {
        console.log("props inside Activate credit is ", this.props);
        console.log("State values are ", this.state);
        const {
            productChoices,
            bzidWarn,
            phoneWarn,
            creditProductWarn,
            businessNameWarn,
            overallLimitWarn,
            showErrorModal,
            isSuccessful,
            phoneNumberLengthWarn,
            startDate,
            isJTUser,
            overallLimitHigherWarn,
            productSelected,
            overallLimit,
            phone,
            businessName,
            newConvenienceFeeRate,
            tenureChoices,
            subsidizedDaysChoices
        } = this.state;
        let maxLimitToDisplay;
        if(productSelected === "JT-PDC"){
            maxLimitToDisplay = 30000
        }
        else{
            maxLimitToDisplay = 15000
        }
        // console.log("limit is ",overallLimit);
        // console.log("maxLimit is ",maxLimitToDisplay);
        return (
            isJTUser === true ?
                <React.Fragment>
                    <h4 className={`textCentre`}>Activate Credit</h4>
                    <form action="javascript:void(0)" className={'clFormContainer'}>
                        <div className={'clSubmitDiv'}>
                            <div className={'clInputRow'}>
                                <div className={'clNameDiv'}>
                                    <label className={'clLabel'} htmlFor="bzid">BZID<span> *</span></label>
                                    {bzidWarn ? <label className={'clWarning'}> BZID cannot be empty! </label> : ""}
                                    <div className={"d-flex flex-column flex-md-row bd-highlight"}>
                                        <input className={'clBzidInput'} name="bzid" id="bzid" placeholder="Enter BZID"
                                               onChange={this.handleFormData} value={this.state.bzid}></input>
                                        <button onClick={this.searchBzid} type={"submit"}
                                                className={"btn btn-sm btn-secondary"}>Search
                                        </button>
                                    </div>
                                </div>
                                <div className={'clNameDiv'}>
                                    <label className={'clLabel'} htmlFor="phone">Phone Number<span> *</span></label>
                                    {phoneNumberLengthWarn ?
                                        <label className={'clWarning'}> Phone number should be of 10
                                            digits! </label> : ""}
                                    {phoneWarn && phone.length <= 0?
                                        <label className={'clWarning'}> Phone number cannot be empty! </label> : ""}
                                    <input name="phone" placeholder="Enter phone number" value={phone}
                                           onChange={this.handleFormData}></input>
                                </div>
                            </div>
                            <div className={'clInputRow'}>
                                <div className={'clNameDiv'}>
                                    <label className={'clFilterTextLabel'} htmlFor="startDate">Start Date</label>
                                    <div>
                                        <input type="date" name="startDate" id="date"
                                               className="textbox-n clFilterText form-control" value={startDate}
                                               onChange={this.handleFormData}/>
                                    </div>
                                </div>
                                <div className={'clNameDiv'}>
                                    <label className={'clLabel'} htmlFor="businessName">Business
                                        Name<span> *</span><span> </span></label>
                                    {businessNameWarn && businessName.length <= 0 ?
                                        <label className={'clWarning'}> Business name cannot be empty! </label> : ""}
                                    <input name="businessName" placeholder="Enter Business Name"
                                           value={businessName} onChange={this.handleFormData}></input>
                                </div>
                            </div>
                            <div className={'clInputRow'}>
                                <div className={'clNameDiv'}>
                                    <label className={'clLabel'} htmlFor="productSelected">Credit
                                        Product<span> *</span></label>
                                    {creditProductWarn ?
                                        <label className={'clWarning'}> Credit product cannot be empty! </label> : ""}
                                    <select className="custom-select custom-select-lg"
                                            value={this.state.productSelected}
                                            style={{borderBottom:"1px solid gray"}}
                                            name="productSelected" onChange={(e) => this.handleSelect(e)}>
                                        {
                                            productChoices.map((item) => (
                                                item === "JT-PDC" ?
                                                    <option key={uuidv4()} value={item} selected>{item}</option>
                                                    : <option key={uuidv4()} value={item}>{item}</option>
                                            ))
                                        }
                                    </select>
                                </div>
                                <div className={'clNameDiv'}>
                                    <label className={'clLabel'} htmlFor="overallLimit">Overall
                                        Limit<span> *</span></label>
                                    {overallLimitHigherWarn && parseInt(overallLimit) > maxLimitToDisplay  ?
                                        <label className={'clWarning'}> Exceeded Limit!, max limit is {maxLimitToDisplay} for {productSelected} </label> : ""}
                                    {overallLimitWarn ?
                                        <label className={'clWarning'}> Overall limit cannot be empty! </label> : ""}
                                    <input name="overallLimit" value={overallLimit}
                                           placeholder="30000" onChange={this.handleFormData} style={{marginTop:"2%"}}></input>
                                </div>
                            </div>
                            <div className={"clCardView"}>
                                <div className={'clInputRow'}>
                                    <div className={'clNameDiv'}>
                                        <label className={'clLabel'} htmlFor="convenienceFeeRate">Convenience Fee
                                            Rate</label>
                                        <input name="convenienceFeeRate" id={"convenienceFeeRate"}
                                               value={newConvenienceFeeRate} readonly></input>
                                    </div>
                                    <div className={'clNameDiv'}>
                                        <label className={'clLabel'} htmlFor="interestRate">Interest Rate</label>
                                        <input name="interestRate" id={"interestRate"} value={this.state.interestRate}
                                               readonly></input>
                                    </div>
                                </div>
                                <div className={'clInputRow'}>
                                    <div className={'clNameDiv'} style={{display:"none"}}>
                                        <label className={'clLabel'} htmlFor="convenienceFeePercent">Convenience Fee
                                            Tax</label>
                                        <input name="convenienceFeePercent" id={"convenienceFeePercent"}
                                               value={this.state.convenienceFeePercent} readonly></input>
                                    </div>
                                    <div className={'clNameDiv'}>
                                        <label className={'clLabel'} htmlFor="tenure">Tenure</label>
                                        {/*<input name="tenure" id={"tenure"}*/}
                                        {/*       value={this.state.tenure} readOnly></input>*/}
                                        <select className="custom-select custom-select-lg"
                                                value={this.state.tenure}
                                                name="tenure" onChange={(e) => this.handleTenureSelect(e)}
                                                style={{background:"#E6E6E7",outline:"none",borderBottom:"1px solid gray"}}>
                                            {
                                                tenureChoices.map((item) => (
                                                    item === 21 ?
                                                        <option key={uuidv4()} value={item} selected>{item}</option>
                                                        : <option key={uuidv4()} value={item}>{item}</option>
                                                ))
                                            }
                                        </select>
                                    </div>
                                    <div className={'clNameDiv'}>
                                        <label className={'clLabel'} htmlFor="subsidizedDays">Subsidized Days</label>
                                            <select className="custom-select custom-select-lg"
                                                value={this.state.subsidizedDays}
                                                name="subsidizedDays" onChange={(e) => this.handleSubsidizedDaysSelect(e)}
                                                style={{background:"#E6E6E7",outline:"none",borderBottom:"1px solid gray"}}>
                                            {
                                                subsidizedDaysChoices.map((item) => (
                                                    item === 7 ?
                                                        <option key={uuidv4()} value={item} selected>{item}</option>
                                                        : <option key={uuidv4()} value={item}>{item}</option>
                                                ))
                                            }
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div className={'clBtnDiv textCentre'}>
                                <button type={"button"} onClick={this.handleSubmit}>Submit</button>
                            </div>
                        </div>
                    </form>
                    {showErrorModal ? this.showErrorMessageModal() : null}
                    {isSuccessful ? this.showSuccessMessageModal() : null}
                </React.Fragment>
                :
                <React.Fragment>
                    <div>This Section is not open for you yet!</div>
                </React.Fragment>
        )

    }

    showSuccessMessageModal = () => {
        return (
            <ClSuccessPage handleClickedOk={this.handleSuccessModalOk}/>
        )
    };

    showErrorMessageModal = () => {
        return (
            <div>
                <Dialog open={this.state.showErrorModal} aria-labelledby="responsive-dialog-title" maxWidth="sm"
                        classes={{paperWidthSm: "wider-dialoge"}}>
                    <div style={{padding: "1em"}}>
                        <div>
                            <div className="row">
                                <div className="col-md-12">
                                    Error: <div
                                    style={{color: "red"}}>{" " + JSON.stringify(this.state.error["error"])} </div>
                                </div>
                            </div>
                            <div className="row" style={{paddingRight: "2em"}}>
                                <button className="btn btn-jt-ops pull-right" onClick={() => {
                                    this.setState({showErrorModal: false})
                                }}>
                                    OK
                                </button>
                            </div>
                        </div>
                    </div>
                </Dialog>
            </div>
        );
    }
}

export default CreateCreditLine;


// WEBPACK FOOTER //
// ./src/screens/instantCredit/components/createCreditLine.js